import * as React from "react";
import {cx} from "emotion";

import "./step-3-list-name.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {cascadeFind}    from "@Common/utils/cascade";

import {Header}          from "../../common/header/header";
import {ListNameSection} from "../../common/list-name-section/list-name-section";
import {SectionGroup}    from "../../common/section-group";

export const Step3ListName = ({entityId, next}) => cs(
    ["buildings", (_, next) => UseState({
        initValue: [],
        next,
    })],
    ["listName", (_, next) => UseState({next})],
    ({buildings, listName}) => next({
        ready: cascadeFind(buildings.value, "[*].addressList[*]"),

        accept: buildings.onChange,
        render: ({onNext}) => cs(
            ["listNameSection", (_, next) => ListNameSection({
                data: listName,
                name: "Address",
                next,
                xdQaName:"Coop Condo"
            })],
            ["sections", ({listNameSection}, next) => SectionGroup({
                sections: [listNameSection],
                next,
            })],
            consumeContext("apis"),
            ({listNameSection, sections, apis}) => (
                <div className="step-3-list-name-3oe">
                    {Header({
                        icon: require("../../../../mailing-icons/listtype-condo.png"),
                        title: "Create Co-op/Condo Address List",
                        subTitle: "Build a list comprised of multi-family buildings and units on a particular street.",
                    })}


                    <div className="content">

                        <div className="prev-section">

                            <div className="title" xd-qa-type="label" xd-qa-name="Coop Condo List Build Address List">
                                Build Address List
                            </div>
                            <a
                                className="edit"
                                onClick={() => buildings.onChange([])}
                                xd-qa-type="link"
                                xd-qa-name="Coop Condo List Edit link"
                            >
                                Edit
                            </a>
                        </div>

                        {listNameSection.render({showErrors: sections.showErrors})}

                    </div>

                    {/*{console.log(JSON.stringify(data.value, null, 2))}*/}


                    <div className="footer">
                        {cs(
                            ({}) => (
                                <button {...{
                                    className: cx("cancel", {}),
                                    onClick: () => {
                                        buildings.onChange([]);
                                    },
                                    "xd-qa-type": "button",
                                    "xd-qa-name": "Coop Condo List Back Modal button",
                                }}>
                                    Back
                                </button>

                            )
                        )}

                        <button {...{
                            className: cx("next", {disabled: sections.invalid}),
                            disabled: sections.submitDisabled,
                            onClick: () => {
                                    if(hj && typeof hj === 'function')
                                    {
                                        hj('event', `co_op_condo_list_create_click_event`);
                                    }
                                    sections.submit(async () => {
                                    const result = await apis.next.mailing.decondo.createDecondoML({listName: listName.value, buildings: buildings.value, entityId});

                                    if (result.result === "failure") {
                                        alert(result.errors?.msg ?? "Unknown error");
                                    } else {
                                        return onNext(result.idList, listName.value);
                                    }
                                })
                            },
                            "xd-qa-type": "button",
                            "xd-qa-name": "Coop Condo List Complete Modal button",
                        }}>
                            Complete
                        </button>
                    </div>
                </div>
            ),
        ),
    }),
);


